import { Injectable } from "@angular/core";
import { CHttp } from "../../core/services/chttp.service";
import { config } from "../../app.config";

@Injectable()
export class EmailsService {
  constructor(private http: CHttp) {}

  public getAllEmails() {
    return this.http.get(config.api_url + "email-templates");
  }

  public getUserEmails() {
    return this.http.get(config.api_url + "email-templates/users");
  }

  public getAdminEmails() {
    return this.http.get(config.api_url + "email-templates/admins");
  }

  public getUserReportEmails() {
    return this.http.get(config.api_url + "email-templates/users-report");
  }

  public getSubscriptionEmails() {
    return this.http.get(config.api_url + "email-templates/subscriptions");
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/emails/services/emails.service.ts